var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleSecure = function SvgCircleSecure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "#5B9255",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.667a4.171 4.171 0 0 0-4.167 4.166v2.5H11A1.667 1.667 0 0 0 9.333 16v6.667A1.666 1.666 0 0 0 11 24.333h10a1.666 1.666 0 0 0 1.667-1.666V16A1.667 1.667 0 0 0 21 14.333h-.833v-2.5A4.171 4.171 0 0 0 16 7.667Zm-2.5 4.166c0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5v2.5h-5v-2.5Zm3.333 8.936v1.898h-1.666v-1.898a1.66 1.66 0 0 1 .472-3.064 1.667 1.667 0 0 1 1.803 2.458 1.658 1.658 0 0 1-.609.606Z",
    fill: "#5B9255"
  })));
};
export default SvgCircleSecure;